import { ReactNode } from 'react';

import { scale } from '@scripts/gds';
import { useMedia } from '@scripts/hooks';
import { themeColor } from '@scripts/themes/cssVars';

const LogoContainer = ({ children }: { children?: ReactNode }) => {
    const { sm } = useMedia();

    return (
        <div
            css={{
                height: scale(20),
                width: scale(25),
                [sm]: {
                    width: '100%',
                },
                border: `1px solid ${themeColor.middleBackground}`,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
            }}
        >
            {children}
        </div>
    );
};

export default LogoContainer;
